import React from "react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../ShearCompo/BreadCrumb/BreadCrumb";
import ChoiceCarousel from "./Carousel/ChoiceCarousel";
import './scss/OurChoice.scss';

const OursChoice = () => {
    let { t } = useTranslation();
    const imgArr = [
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img1.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img10.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img2.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img3.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img4.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img5.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img6.png",
        },
    ];
    // https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img7.png
    // https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img8.png
    // https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img9.png

    return (
        <div className="">
            <BreadCrumb title={t("ourchoice")} />

            <div className="mt-2 img_parent">
                <ChoiceCarousel images={imgArr} arrows />
                <div className="border-b-4 border-dashed border-gray-800"></div>
            </div>
        </div>
    );
};

export default OursChoice;
